export class JobOpeningsVo {
    id: any;
    category: any;
    domain: any;
    location: any;
    employer:any;
    description: any;
    link: any;
    jobDescriptions:any;
    minMaxYrsOfExp: any;
    skills: any;
    jobRefference_ID: any;
    applyUrl: any;
    referranceEmailID: any;
    contentDetails: any;
    allowToContact:  any;
    createdDate:any;
    tags: string[]=[];
    linkMetaData:any;
    userId:any;

    
    // emailID: any;
    // yrsOfExp: any;
    // isContact: any;
    // catergory:any;
    // phoneNumber:any;
    
}
